document.addEventListener('DOMContentLoaded', function() {
  // Espera un momento para que el DOM esté completamente cargado
  setTimeout(function() {
    // Busca la sección de colección destacada por su ID
    const featuredSection = document.querySelector('[id*="featured_collection"]');
    
    if (featuredSection) {
      // Busca el contenedor de productos (ul.grid)
      const productGrid = featuredSection.querySelector('ul.grid');
      
      if (productGrid) {
        // Obtiene todos los productos (li elementos)
        const products = Array.from(productGrid.children);
        
        console.log('Productos encontrados:', products.length); // Para debug
        
        // Mezcla aleatoriamente los productos (algoritmo Fisher-Yates)
        for (let i = products.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [products[i], products[j]] = [products[j], products[i]];
        }
        
        // Reordena los productos en el DOM
        products.forEach(product => productGrid.appendChild(product));
        
        console.log('Productos reordenados aleatoriamente'); // Para debug
      } else {
        console.log('No se encontró el grid de productos');
      }
    } else {
      console.log('No se encontró la sección de colección destacada');
    }
  }, 100); // Espera 100ms
});
